import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  to: '/work',
  label: 'Work'
}, {
  to: '/fleet',
  label: 'Our Fleet'
}, {
  to: '/about',
  label: 'About'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-50 border-b border-line bg-ink/90 backdrop-blur-sm" data-id="element-38" data-mp="2wl8lj9740ykc">
      <div className="mx-auto flex max-w-page items-center justify-between px-6 py-4 md:px-10" data-id="element-39" data-mp="31bysurz3jbho">
        <Link to="/" aria-label="Breezy Experiential — home" className="block" data-id="element-40" data-mp="36b208j2jttst">
          <img src="https://cdn.magicpatterns.com/uploads/javFhNUJ7GVHe95isNt3eZ/Breezy-logo-stacked-lime.png" alt="Breezy Experiential" className="h-9 w-auto transition-opacity hover:opacity-70 md:h-10" data-id="element-41" data-mp="36d4n4u8en6tb" />
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-10 md:flex" data-id="element-42" data-mp="2wlm8ne6n24jw">
          {links.map(link => <NavLink key={link.to} to={link.to} className={({
          isActive
        }) => `text-[0.7rem] uppercase tracking-micro transition-colors ${isActive ? 'text-sage' : 'text-cream/65 hover:text-cream'}`} data-id="element-43" data-mp="2rk6qbtvuic57">
              {link.label}
            </NavLink>)}
          <Link to="/contact" className="rounded-full bg-lilac px-5 py-2.5 text-[0.65rem] uppercase tracking-micro text-ink transition-colors hover:bg-sage" data-id="element-44" data-mp="3adkbx8do5685">
            Start a project
          </Link>
        </nav>

        <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="-mr-2 p-2 text-cream md:hidden" data-id="element-45" data-mp="1wfs0utt0p0i">
          {open ? <XIcon size={20} data-id="element-46" data-mp="1rew8aj4c8tro" /> : <MenuIcon size={20} data-id="element-47" data-mp="1rfo2pqm78lgd" />}
        </button>
      </div>

      {open && <nav aria-label="Mobile" className="border-t border-line bg-ink px-6 py-2 md:hidden" data-id="element-48" data-mp="1wc4qgjphkxsx">
          {links.map(link => <NavLink key={link.to} to={link.to} className={({
        isActive
      }) => `block border-b border-line py-3.5 font-display text-2xl font-semibold uppercase last:border-0 ${isActive ? 'text-sage' : 'text-cream'}`} data-id="element-49" data-mp="1mmbdpfdlycn3">
              {link.label}
            </NavLink>)}
        </nav>}
    </header>;
}